// extracted by mini-css-extract-plugin
export default {"note":"styles_note__kj3qk","buttons":"styles_buttons__eyb6c","button":"styles_button__fZNAy","cancelButton":"styles_cancelButton__gEouy"};